import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const geo = {
  fetchGeo: lazyModuleMethod(() => import('./fetchGeo'), 'default'),
}
